import gql from 'graphql-tag';

export const PREVIEWS_MUTATION = gql`
  mutation PreviewsMutation(
    $campaignId: ID!
    $articleGroupId: ID!
    $adFormat: AdFormatEnum!
    $previewParams: [CreativeTemplatePreviewInput!]!
    $articleId: ID
  ) {
    generateCreativeTemplatesPreviews(
      campaignId: $campaignId
      articleGroupId: $articleGroupId
      adFormat: $adFormat
      previewParams: $previewParams
      articleId: $articleId
    ) {
      previews
      errors
    }
  }
`;
